export default {
  matching: {
    training: {
      legend: "Aktiviert das Modul & die Anzeige im Katalog",
      domains: {
        delete: {
          title: "Diesen Ausbildungsbereich löschen",
        },
      },
    },
    group: {
      title: "Gruppe",
      legend: "Öffnet oder schließt die Bewerbungen",
    },
    groups: {
      title: ({ plural }) => plural(["Gruppe", "Gruppen"]),
      edit: {
        title: "Gruppenblatt bearbeiten",
      },
      view: {
        title: "Gruppenblatt ansehen",
      },
      sheet: {
        title: "Gruppenblatt",
        title_with_name: "Gruppenblatt — {name}",
        candidacy_opening_section: "Öffnung der Bewerbungen",
        objectives_section: "Ziele & Aufnahmekapazität",
        save_success: "Gruppenblatt gespeichert",
      },
      candidacy_status_upcoming: "Demnächst",
      candidacy_status_open: "Offen",
      candidacy_status_finalized: "Abgeschlossen",
      candidacy_status_full: "Voll",
      candidacy_status_full_waitlist: "Voll — Warteliste",
      candidacy_status_closed: "Geschlossen",
    },
    prospects: {
      title: ({ plural }) => plural(["Interessent", "Interessenten"]),
      view: {
        title: "Datensatz ansehen",
      },
      send_email: {
        title: "E-Mail senden",
      },
      filters: {
        title: "Schnellfilter",
        active: "Aktiv",
        passive: "Passiv",
        unsubscribed: "Abgemeldet",
        candidates: "Bewerber",
        stages_title: "Bewerber nach Schritt filtern",
        advanced: {
          title: "Suchen",
          search_label: "Nach Name oder E-Mail suchen",
          results_announcement: ({ plural, named }) =>
            plural(["Keine Ergebnisse", `${named("count")} Ergebnis`, `${named("count")} Ergebnisse`]),
        },
      },
    },
    unsubscribeStats: {
      title: "Abmeldungen",
      total: ({ plural, named }) => plural([`${named("count")} Abmeldung`, `${named("count")} Abmeldungen`]),
      by_reason: "Aufschlüsselung nach Grund",
      evolution: "Entwicklung im Zeitverlauf",
      reason: "Grund",
      count: "Anzahl",
      from: "Startzeitraum (Monat)",
      to: "Endzeitraum (Monat)",
    },
    settings: {
      success: "Speicherung erfolgt. Die Änderungen sind jetzt aktiv.",
    },
    config: {
      candidateWorkflow: {
        edit_title: "Reiter „{name}“ bearbeiten",
        edit_success: "Reiter gespeichert",
        blocks: {
          edit_title: "Block „{name}“ bearbeiten",
          edit_success: "Block gespeichert",
        },
        fields: {
          edit_title: "Feld „{name}“ bearbeiten",
          edit_success: "Feld gespeichert",
          conditional: "Nur sichtbar, wenn „{target}“ ausgefüllt ist",
        },
        steps: {
          intro: "Etappen",
          edit_title: "Etappe „{name}“ bearbeiten",
          edit_success: "Etappe gespeichert",
        },
      },
    },
    catalog: {
      title: ({ plural }) => plural(["Katalog", "Kataloge"]),
      edit: {
        title: "Katalogblatt bearbeiten",
      },
      view: {
        title: "Katalogblatt ansehen",
      },
      sheet: {
        title: "Katalogblatt",
        title_with_name: "Katalogblatt — {name}",
        subtitle: "Im Katalog und auf der Landingpage sichtbare Elemente",
        mode_edit: "Bearbeitungsmodus",
        mode_view: "Nur Lesen — Recht nicht erteilt",
        presentation_image: "Präsentationsbild",
        presentation_text: "Präsentationstext",
        commercial_brochure: "Werbebroschüre",
        website_url: "Website-URL",
        no_file: "Keine Datei",
        qr_code_alt: "QR-Code des Katalogblatts",
        qr_url_label: "Vom QR-Code kodierter Link",
        save_success: "Katalogblatt gespeichert",
        download_unavailable: "Keine Broschüre zum Herunterladen verfügbar.",
        actions: {
          replace: "Ersetzen",
          remove: "Entfernen",
          download: "Herunterladen",
          copy: "Bild kopieren",
          copy_success: "QR-Code in die Zwischenablage kopiert!",
          copy_error: "Der QR-Code konnte nicht kopiert werden.",
          copy_unsupported: "Ihr Browser unterstützt das Kopieren von Bildern nicht.",
          copy_url: "Link kopieren",
          copy_url_success: "Link in die Zwischenablage kopiert!",
          copy_url_error: "Der Link konnte nicht kopiert werden.",
          uploading: "Datei wird hochgeladen…",
          upload_error: "Beim Hochladen der Datei ist ein Fehler aufgetreten.",
        },
      },
    },
    landing_page: {
      add: {
        title: "Herkunft hinzufügen",
        success: "Herkunft erfolgreich hinzugefügt!",
      },
      edit: {
        title: "Diese Herkunft bearbeiten",
        success: "Herkunft erfolgreich geändert!",
      },
      delete: {
        title: "Diese Herkunft löschen",
        confirmation: "Sind Sie sicher, dass Sie diese Landingpage-Herkunft löschen möchten?",
        success: "Landingpage-Herkunft erfolgreich gelöscht!",
      },
      qr_code: {
        see: "QR-Code anzeigen",
        title: "QR-Code der Landingpage",
        alt: "QR-Code der Landingpage",
        download: "Herunterladen",
        copy: "Bild kopieren",
        copy_success: "QR-Code in die Zwischenablage kopiert!",
        copy_error: "Der QR-Code konnte nicht kopiert werden.",
        copy_unsupported: "Ihr Browser unterstützt das Kopieren von Bildern nicht.",
      },
      url: {
        copy: {
          title: "Link kopieren",
          success: "Link erfolgreich kopiert!",
        },
      },
      filters: {
        level: {
          label: "Angestrebtes Studienniveau",
          unknown: "Ich weiß es nicht",
          load_error: "Die Niveaus konnten nicht geladen werden, bitte versuchen Sie es erneut.",
          retry: "Erneut versuchen",
        },
        domain: {
          label: "Ausbildungsbereich",
          hint_multiple: "(Mehrfachauswahl möglich)",
          search_placeholder: "Einen Bereich suchen (z. B. IT, Handel…)",
          empty_search: "Kein Bereich entspricht „{search}“.",
          select_level_first: "Wählen Sie ein Studienniveau, um die verfügbaren Bereiche zu sehen.",
          show_all: "Alle {count} Bereiche anzeigen",
          collapse: "Bereiche einklappen",
          load_error: "Die Bereiche konnten nicht geladen werden, bitte versuchen Sie es erneut.",
          retry: "Erneut versuchen",
          remove: "{name} entfernen",
          formation_count: ({ plural, named }) =>
            plural([`${named("count")} Ausbildung`, `${named("count")} Ausbildungen`]),
        },
        training: {
          label: "Verfügbare Ausbildungen",
          search_placeholder: "Eine Ausbildung anhand von Stichwörtern suchen…",
          selected_count: ({ plural, named }) =>
            plural([
              `${named("count")}/${named("max")} Ausbildung ausgewählt`,
              `${named("count")}/${named("max")} Ausbildungen ausgewählt`,
            ]),
          // Ohne Obergrenze (attr["data-max-count"] fehlt) : kein "/{max}" anzuzeigen.
          selected_count_no_max: ({ plural, named }) =>
            plural([`${named("count")} Ausbildung ausgewählt`, `${named("count")} Ausbildungen ausgewählt`]),
          total_count: ({ plural, named }) => plural([`${named("total")} Ergebnis`, `${named("total")} Ergebnisse`]),
          load_more: ({ plural, named }) =>
            plural([
              `${named("count")} weitere Ausbildung anzeigen (${named("remaining")} verbleibend)`,
              `${named("count")} weitere Ausbildungen anzeigen (${named("remaining")} verbleibend)`,
            ]),
          adapted_to_level: "Passend zu Ihrem Niveau",
          empty: "Derzeit entspricht keine Ausbildung diesen Kriterien.",
          more_info: "Mehr Infos",
          close: "Schließen",
          select: "Diese Ausbildung auswählen",
          selected: "Ausbildung ausgewählt",
          max_selection_reached: "Sie können höchstens {max} Ausbildungen auswählen.",
          load_error: "Die Ausbildungen konnten nicht geladen werden, bitte versuchen Sie es erneut.",
          retry: "Erneut versuchen",
        },
      },
    },
    candidateStudies: {
      title: "Meine Ausbildung",
      intro: "Geben Sie Ihre Abschlüsse und Zertifikate an, um Ihre Bewerbung zu vervollständigen.",
      add: "Hinzufügen",
      add_degree_title: "Abschluss hinzufügen",
      edit_degree_title: "Diesen Abschluss bearbeiten",
      add_certification_title: "Zertifikat hinzufügen",
      edit_certification_title: "Dieses Zertifikat bearbeiten",
      save_success: "Eintrag gespeichert",
      empty: "Noch kein Eintrag vorhanden",
      minimum_not_reached: "Fügen Sie mindestens einen Eintrag hinzu, um diesen Block zu vervollständigen",
      max_reached_tooltip: "Maximale Anzahl an Einträgen erreicht",
      delete_confirm_title: "Diesen Eintrag löschen?",
      delete_success: "Eintrag gelöscht",
      move_up: "Nach oben",
      move_down: "Nach unten",
      moved: "{name}: Eintrag Nummer {position} von {total}.",
      reorder_error:
        "Die Reihenfolge Ihrer Einträge konnte nicht gespeichert werden, die vorherige Reihenfolge wurde beibehalten.",
      entry: {
        edit: "Bearbeiten",
        delete: "Löschen",
        degree_type: "Abschlussart",
        institution: "Schule",
        department: "Département",
        country: "Land",
        year: "Jahr",
        organization: "Organisation",
      },
    },
    candidateInformation: {
      read_only_notice: "Dieser Tab kann in dieser Phase Ihrer Akte nicht mehr bearbeitet werden.",
      steps_title: "Meine Akte",
      title: "Meine Angaben",
      tab_empty: "Dieser Tab wird in Kürze verfügbar sein.",
      load_error: "Ihre Akte konnte nicht geladen werden, bitte versuchen Sie es erneut.",
      retry: "Erneut versuchen",
    },
    applications: {
      hint_reorder:
        "Ordnen Sie Ihre Wünsche nach Präferenz: Ziehen Sie eine Karte am Griff oder nutzen Sie die Schaltflächen Nach oben und Nach unten.",
      empty: "Sie haben noch keinen Bewerbungswunsch.",
      rank: ({ named }) => `${named("rank")}. Wunsch`,
      move_up: "Wunsch {name} nach oben verschieben",
      move_down: "Wunsch {name} nach unten verschieben",
      moved: "{name}: Wunsch Nummer {position} von {total}.",
      reorder_error:
        "Die Reihenfolge Ihrer Wünsche konnte nicht gespeichert werden, die vorherige Reihenfolge bleibt erhalten.",
      closed_title: "Abgeschlossene Wünsche",
      view: "Ansehen",
      edit: "Bearbeiten",
      tab_count: "{count} aktiver Wunsch | {count} aktive Wünsche",
      modal: {
        title: "Mein Wunsch",
        training: "Ausbildung",
        group: "Gruppe",
        status: "Status",
        year: "Jahr",
        letter_label: "Motivationsschreiben",
        letter_hint: "Höchstens {max} Zeichen.",
        letter_counter: "{count} / {max} Zeichen",
        letter_locked: "Ihr Motivationsschreiben kann in dieser Phase nicht mehr bearbeitet werden.",
        save: "Speichern",
        close: "Schließen",
        saved: "Motivationsschreiben gespeichert",
        withdraw: "Diesen Wunsch zurückziehen",
        withdraw_confirm: "Möchten Sie diesen Wunsch wirklich zurückziehen?",
        withdraw_confirm_yes: "Ja, Wunsch zurückziehen",
        withdraw_cancel: "Abbrechen",
        withdrawn: "Wunsch zurückgezogen",
      },
    },
  },
};
